import Grid from "@material-ui/core/Grid";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { radioinputconverter } from "Component/DynamicForm/Fields/Radio";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import DynamicForm from "Component/DynamicForm";
import { ErrorMessages } from "Constants";
import pointingHandIcon from "Assets/Svg/hand-pointing-right.svg";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import selfImg from "Assets/Svg/self.svg";
import managerImg from "Assets/Svg/managermask.svg";
import { isSpaceInString } from "Utils";
import coworkerImg from "Assets/Svg/co-worker.svg";

import directreportImg from "Assets/Svg/direct-report.svg";

import { instance } from "../../../../../../Actions/AxiosInstance";

const openformoptions = [
  {
    // displayname: "Open on a specific day for all participants",
    displayname: "Set one custom date for all participants",
    displayvalue: 1,
  },
  {
    // displayname: "Open the form on different date for different participants",
    displayname: "Set individual custom dates for each participant",
    displayvalue: 2,
  },
];

const formopenoptions = [
  {
    displayname: "Open at start of review period",
    displayvalue: 3,
  },
  {
    displayname: "Set one custom date for all participants",
    displayvalue: 1,
  },
  {
    displayname: "Set individual custom dates for each participant",
    displayvalue: 2,
  },
];

const formcloseoptions = [
  {
    displayname: "Close at end of review period",
    displayvalue: 3,
  },
  {
    displayname: "Set one custom date for all participants",
    displayvalue: 1,
  },
  {
    displayname: "Set individual custom dates for each participant",
    displayvalue: 2,
  },
];

// const monthArray = [
//   { id: "1", name: "Jan" },
//   { id: "2", name: "Feb" },
//   { id: "3", name: "Mar" },
//   { id: "4", name: "Apr" },
//   { id: "5", name: "May" },
//   { id: "6", name: "Jun" },
//   { id: "7", name: "Jul" },
//   { id: "8", name: "Aug" },
//   { id: "9", name: "Sep" },
//   { id: "10", name: "Oct" },
//   { id: "11", name: "Nov" },
//   { id: "12", name: "Dec" },
// ];
class reviewperiod extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      selectedReview: props.selectedReview,
      monthArray: props.monthArray,
      participant: props.selectedReview.participant,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);

    // this.onSaveDraft = this.onSaveDraft.bind(this);
  }

  async componentDidMount() {
    this.props.onRef({
      onNext: this.onSubmit,
    });
  }

  handleChange(key, value) {
    // this.setState({
    //   monthArray: newMonthArray,
    // });
    const { selectedReview } = this.state;
    if (key == "isprimarymanager" || key == "issecondarymanager" || key == "ismanagersmanager") {
      selectedReview.participant[1][key] = value;
    }
    else if (key == "reviewperiodtypeid") {
      selectedReview.reviewtypeid = 1;
      selectedReview.isformalwaysopen =
        selectedReview.isformalwaysopen == null
          ? true
          : selectedReview.isformalwaysopen;
      selectedReview.reviewperiodtypeid = value;
    } else if (key == "reviewtypeid" && value == 2) {
      selectedReview.reviewperiodtypeid = null;
      selectedReview.isformalwaysopen = null;
      selectedReview.formopentypeid = null;
      selectedReview.formclosetypeid = null;
      selectedReview.reviewtypeid = value;
    } else {
      selectedReview[key] = value;
    }

    this.setState({
      selectedReview,
    });
  }

  handleChange1(key, value, participanttypeid) {
    console.log("participanttypeid: ", participanttypeid);
    console.log("value: ", value);
    console.log("key: ", key);
    const { participant, selectedReview } = this.state;

    if (
      selectedReview.formopentypeid == 1 &&
      (key == "openday" || key == "frequencytypeid")
    ) {
      participant[0][key] = value;
      participant[1][key] = value;
      participant[2][key] = value;
      participant[3][key] = value;
    }
    if (key == "isSelected" && selectedReview.isformalwaysopen == true) {
      participant[participanttypeid - 1][key] = value;
      participant[participanttypeid - 1].closeday = 1;
      participant[participanttypeid - 1].openday = 1;
    } else if(key == "isemppeerdecide") {
      participant[participanttypeid - 1][key] = value;
      if(value == true) {
        participant[3].isSelected = false
      }
    } else {
      participant[participanttypeid - 1][key] = value;
    }

    console.log(participant[participanttypeid - 1].key, value);
    this.setState({
      participant,
    });
  }

  onSubmit() {
    const { selectedReview, participant } = this.state;
    selectedReview.participant = participant;

    if (selectedReview.reviewperiodtypeid == 1) {
      participant[0].frequencytypeid = 1;
      participant[1].frequencytypeid = 1;
      participant[2].frequencytypeid = 1;
      participant[3].frequencytypeid = 1;
    }
    if (selectedReview.reviewperiodtypeid == null) {
      participant[0].frequencytypeid = null;
      participant[1].frequencytypeid = null;
      participant[2].frequencytypeid = null;
      participant[3].frequencytypeid = null;
    }

    if (selectedReview.structurename && !isSpaceInString(selectedReview.structurename)) {
      this.state.selectedReview.structurename = this.state.selectedReview.structurename.trim();
      
    }

    if (!selectedReview.structurename) {
      this.props.enqueueSnackbar("Please add structure name", {
        variant: "error",
      });
    } 
 else if (!selectedReview.reviewtypeid) {
      this.props.enqueueSnackbar("Please select review period", {
        variant: "error",
      });
    } else if (selectedReview.reviewtypeid != 2 && !selectedReview.formopentypeid) {
      this.props.enqueueSnackbar("Please select when to open the review ", {
        variant: "error",
      });
    } else if (selectedReview.reviewtypeid != 2 && !selectedReview.formclosetypeid) {
      this.props.enqueueSnackbar("Please select when to close the review ", {
        variant: "error",
      });
    } else if (
      !participant[0].isSelected &&
      !participant[1].isSelected &&
      !participant[2].isSelected &&
      !participant[3].isSelected
    ) {
      this.props.enqueueSnackbar("Please select atleast one ", {
        variant: "error",
      });
    }
    // else if (
    //   participant[0].isSelected &&
    //   selectedReview.reviewtypeid != 2 &&
    //   ((selectedReview.isformalwaysopen == false && !participant[0].closeday) ||
    //     !participant[0].openday ||
    //     (selectedReview.reviewperiodtypeid !== 1 &&
    //       selectedReview.isformalwaysopen == false &&
    //       !participant[0].frequencytypeid))
    // ) {
    //   this.props.enqueueSnackbar("Please fill all the data of employee ", {
    //     variant: "error",
    //   });
    // } else if (
    //   participant[1].isSelected &&
    //   selectedReview.reviewtypeid != 2 &&
    //   ((selectedReview.isformalwaysopen == false && !participant[1].closeday) ||
    //     !participant[1].openday ||
    //     (selectedReview.reviewperiodtypeid !== 1 &&
    //       selectedReview.isformalwaysopen == false &&
    //       !participant[1].frequencytypeid))
    // ) {
    //   // this.props.enqueueSnackbar("Please fill all the data of managers ", {
    //   //   variant: "error",
    //   // });
    // } else if (
    //   participant[1].isSelected &&
    //   selectedReview.reviewtypeid != 2 &&
    //   ((selectedReview.isformalwaysopen == false && !participant[1].closeday) ||
    //     !participant[1].openday ||
    //     (selectedReview.reviewperiodtypeid !== 1 &&
    //       selectedReview.isformalwaysopen == false &&
    //       !participant[1].frequencytypeid) ||
    //     (!participant[1].isprimarymanager &&
    //       !participant[1].issecondarymanager &&
    //       !participant[1].ismanagersmanager))
    // ) {
    //   // this.props.enqueueSnackbar(
    //   //   "Please select atleast one of the checkbox of managers ",
    //   //   { variant: "error" },
    //   // );
    // } else if (
    //   participant[2].isSelected &&
    //   selectedReview.reviewtypeid != 2 &&
    //   ((selectedReview.isformalwaysopen == false && !participant[2].closeday) ||
    //     !participant[2].openday ||
    //     (selectedReview.reviewperiodtypeid !== 1 &&
    //       selectedReview.isformalwaysopen == false &&
    //       !participant[2].frequencytypeid))
    // ) {
    //   // this.props.enqueueSnackbar("Please fill all the data of reports ", {
    //   //   variant: "error",
    //   // });
    // } else if (
    //   participant[3].isSelected &&
    //   selectedReview.reviewtypeid != 2 &&
    //   ((selectedReview.isformalwaysopen == false && !participant[3].closeday) ||
    //     !participant[3].openday ||
    //     (selectedReview.reviewperiodtypeid !== 1 &&
    //       selectedReview.isformalwaysopen == false &&
    //       !participant[3].frequencytypeid))
    // ) {
    //   // this.props.enqueueSnackbar("Please fill all the data of peer ", {
    //   //   variant: "error",
    //   // });
    // }
    else {
      this.props.onNextClick(selectedReview);
    }
  }

  handleBlur(value, key) {
    const { selectedReview } = this.state;
    if (value) {
      instance
        .post("perform/checkuniquereviewsructurename", {
          structurename: value,
          reviewstructureid: selectedReview && selectedReview.reviewstructureid,
        })
        .then((result) => {
          selectedReview[key] = value;
          this.setState({ selectedReview });
        })
        .catch((error) => {
          selectedReview[key] = "";
          this.setState({ selectedReview });
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  render() {
    const {
      structurename,
      reviewperiodtypeid,
      reviewtypeid,
      isformalwaysopen,
      formopentypeid,
      formclosetypeid,
      isemppeerdecide,

    } = this.state.selectedReview;

    const { participant } = this.state;

    return (
      <div className="padding-top-0">
        <div className="">
          <Grid container>
            <Grid item xs={12} md={12} sm={12}>
              <div className="margin-bottom-16" style={{ width: 350 }}>
                <p className="normal-dark margin-bottom-16">
                  Review structure name
                </p>
                <DynamicForm
                  fields={textinputconverter({
                    value: structurename,
                    placeholder:
                      "Example: “Quarterly review - manager review themselves”",
                    label: "",
                  })}
                  onChange={(value) => {
                    this.handleChange("structurename", value);
                  }}
                  onBlur={(value) => {
                    this.handleBlur(value.target.value, "structurename");
                  }}
                />
                <p className="input-label" style={{ marginTop: -12 }}>
                  Example: Quarterly review - Managers review themselves
                </p>
              </div>

              <p className="normal-dark margin-bottom-8 display-flex">
                <img className="margin-right-16" src={pointingHandIcon}></img>{" "}
                Define review period
              </p>
              <p className="small-dark-secondary margin-bottom-16">
                Decide how often you want to run performance reviews
              </p>
              <div className="floatleft margin-right-16">
                <div style={{ width: 140 }}>
                  <DynamicForm
                    className="width100"
                    fields={radioinputconverter({
                      value: reviewperiodtypeid == 1,
                      label: "Monthly",
                    })}
                    onChange={() => this.handleChange("reviewperiodtypeid", 1)}
                  />
                  <DynamicForm
                    className="width100"
                    fields={radioinputconverter({
                      value: reviewperiodtypeid == 2,
                      label: "Quarterly",
                    })}
                    onChange={() => this.handleChange("reviewperiodtypeid", 2)}
                  />
                  <DynamicForm
                    className="width100"
                    fields={radioinputconverter({
                      value: reviewperiodtypeid == 3,
                      label: "Semi-Annually",
                    })}
                    onChange={() => this.handleChange("reviewperiodtypeid", 3)}
                  />
                  <DynamicForm
                    className="width100"
                    fields={radioinputconverter({
                      value: reviewperiodtypeid == 4,
                      label: "Annually",
                    })}
                    onChange={() => this.handleChange("reviewperiodtypeid", 4)}
                  />
                  <DynamicForm
                    className="width100"
                    fields={radioinputconverter({
                      value: reviewtypeid == 2,
                      label: "Manually",
                    })}
                    onChange={() => this.handleChange("reviewtypeid", 2)}
                  />
                </div>
              </div>
              <div className="floatleft">
                {reviewperiodtypeid == 1 && (
                  <div
                    className="helping-hand-wrapper floatleft"
                    style={{ padding: 8, width: 200, height: 160 }}
                  >
                    <p className="helping-hand-text text-center text-center">
                      Monthly
                    </p>
                    <div>
                      {/* {this.state.monthArray.map((month) => (
                        <div
                          className="floatleft small-dark-secondary t-bold"
                          style={{
                            width: 34,
                            padding: "8px 16px",
                            textAlign: "center",
                          }}
                        >
                          {month.name}
                        </div>
                      ))} */}
                      <p className="extra-small-dark-secondary text-center">
                        Every month
                      </p>
                    </div>
                  </div>
                )}
                {reviewperiodtypeid == 2 && (
                  <div
                    className="helping-hand-wrapper floatleft"
                    style={{ padding: 8, width: 200, height: 160 }}
                  >
                    <p className="helping-hand-text text-center">Quarterly</p>
                    <div>
                      <div style={{ padding: "4px 0px" }}>
                        <p className="extra-small-dark-secondary floatleft margin-right-16">
                          Q1
                        </p>
                        <p className="extra-small-dark-secondary floatright">
                          {this.state.monthArray[0].name} to{" "}
                          {this.state.monthArray[2].name}
                        </p>
                        <div className="clear-float"></div>
                      </div>
                      <div style={{ padding: "4px 0px" }}>
                        <p className="extra-small-dark-secondary floatleft margin-right-16">
                          Q2
                        </p>
                        <p className="extra-small-dark-secondary floatright">
                          {this.state.monthArray[3].name} to{" "}
                          {this.state.monthArray[5].name}
                        </p>
                        <div className="clear-float"></div>
                      </div>
                      <div style={{ padding: "4px 0px" }}>
                        <p className="extra-small-dark-secondary floatleft margin-right-16">
                          Q3
                        </p>
                        <p className="extra-small-dark-secondary floatright">
                          {this.state.monthArray[6].name} to{" "}
                          {this.state.monthArray[8].name}
                        </p>
                        <div className="clear-float"></div>
                      </div>
                      <div style={{ padding: "4px 0px" }}>
                        <p className="extra-small-dark-secondary floatleft margin-right-16">
                          Q4
                        </p>
                        <p className="extra-small-dark-secondary floatright">
                          {this.state.monthArray[9].name} to{" "}
                          {this.state.monthArray[11].name}
                        </p>
                        <div className="clear-float"></div>
                      </div>
                    </div>
                  </div>
                )}
                {reviewperiodtypeid == 3 && (
                  <div
                    className="helping-hand-wrapper floatleft"
                    style={{ padding: 8, width: 200, height: 160 }}
                  >
                    <p className="helping-hand-text text-center">
                      Semi-annually
                    </p>
                    <div>
                      <div style={{ padding: "4px 0px" }}>
                        <p className="extra-small-dark-secondary floatleft margin-right-16">
                          1st half
                        </p>
                        <p className="extra-small-dark-secondary floatright">
                          {this.state.monthArray[0].name} to{" "}
                          {this.state.monthArray[5].name}
                        </p>
                        <div className="clear-float"></div>
                      </div>
                      <div style={{ padding: "4px 0px" }}>
                        <p className="extra-small-dark-secondary floatleft margin-right-16">
                          2nd half
                        </p>
                        <p className="extra-small-dark-secondary floatright">
                          {this.state.monthArray[6].name} to{" "}
                          {this.state.monthArray[11].name}
                        </p>
                        <div className="clear-float"></div>
                      </div>
                    </div>
                  </div>
                )}
                {reviewperiodtypeid == 4 && (
                  <div
                    className="helping-hand-wrapper floatleft"
                    style={{ padding: 8, width: 200, height: 160 }}
                  >
                    <p className="helping-hand-text text-center">Annually</p>
                    <div>
                      <div style={{ padding: "4px 0px" }}>
                        {/* <p className="extra-small-dark-secondary floatleft margin-right-16">
                          Full year
                        </p> */}
                        <p className="extra-small-dark-secondary text-center">
                          {this.state.monthArray[0].name} to{" "}
                          {this.state.monthArray[11].name}
                        </p>
                        <div className="clear-float"></div>
                      </div>
                    </div>
                  </div>
                )}
                {reviewperiodtypeid == 5 && (
                  <div
                    className="helping-hand-wrapper floatleft"
                    style={{ padding: 8, width: 200, height: 160 }}
                  >
                    <p className="helping-hand-text text-center">Manual</p>
                    <div>
                      <div style={{ padding: "8px 16px" }}>
                        <p className="extra-small-dark-secondary margin-right-16 text-center">
                          If your review period is in the past, you must
                          manually end this review once all the reviewers submit
                          their reviews.
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                {reviewperiodtypeid == 6 && (
                  <div
                    className="helping-hand-wrapper floatleft"
                    style={{ padding: 8, width: 200 }}
                  >
                    <p className="helping-hand-text text-center">Triggered</p>
                    <div>
                      <div style={{ padding: "8px 16px" }}>
                        <p className="extra-small-dark-secondary margin-right-16 text-center">
                          The triggering event will be selected while creating
                          the review form.
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="clear-float"></div>
              <p className="normal-dark margin-bottom-8 display-flex">
                <img className="margin-right-16" src={pointingHandIcon}></img>{" "}
                Select review participants
              </p>
              <p className="small-dark-secondary margin-bottom-24">
                Decide who will be filling review forms for the employee
              </p>
              <div className="margin-bottom-24 display-flex">
                <div
                  style={{
                    width: 200,
                    height: 184,
                    background: "#edf5fd",
                    padding: "16px 0px 0px 16px",
                    position: "relative",
                    marginRight: 16,
                  }}
                >
                  <div
                    style={{
                      width: "calc(100% - 32px)",
                      height: "100%",
                    }}
                  >
                    <DynamicForm
                      fields={checkboxinputconverter({
                        value: participant[0].isSelected,
                        placeholder: "",
                        label: "Self",
                        // disabled: participant[0].isSelected == false ? true : false,
                      })}
                      onChange={(value) =>
                        this.handleChange1("isSelected", value, 1)
                      }
                    />
                  </div>
                  <img
                    style={{ position: "absolute", top: 0 }}
                    src={selfImg}
                  ></img>
                </div>
                <div
                  style={{
                    width: 200,
                    height: 184,
                    background: "#edf5fd",
                    padding: "16px 0px 0px 16px",
                    position: "relative",
                    marginRight: 16,
                  }}
                >
                  <div
                    style={{
                      width: "calc(100% - 32px)",
                      height: "100%",
                    }}
                  >
                    <DynamicForm
                      fields={checkboxinputconverter({
                        value: participant[1] && participant[1].isSelected,
                        placeholder: "",
                        label: "Manager",
                        // disabled: participant[1].isSelected == false ? true : false,
                      })}
                      onChange={(value) =>
                        this.handleChange1("isSelected", value, 2)
                      }
                    />
                    <img
                      style={{ position: "absolute", top: 0 }}
                      src={managerImg}
                    ></img>
                  </div>
                </div>
                <div
                  style={{
                    width: 200,
                    height: 184,
                    background: "#edf5fd",
                    padding: "16px 0px 0px 16px",
                    position: "relative",
                    marginRight: 16,
                  }}
                >
                  <div
                    style={{
                      width: "calc(100% - 32px)",
                      height: "100%",
                    }}
                  >
                    <DynamicForm
                      fields={checkboxinputconverter({
                        value: participant[2] && participant[2].isSelected,
                        placeholder: "",
                        label: "Junior employee",
                        // disabled: participant[2].isSelected == false ? true : false
                      })}
                      onChange={(value) =>
                        this.handleChange1("isSelected", value, 3)
                      }
                    />
                    <img
                      style={{ position: "absolute", top: 0 }}
                      src={directreportImg}
                    ></img>
                  </div>
                </div>
                <div
                  style={{
                    width: 200,
                    height: 184,
                    background: "#edf5fd",
                    padding: "16px 0px 0px 16px",
                    position: "relative",
                    marginRight: 16,
                  }}
                >
                  <div
                    style={{
                      width: "calc(100% - 32px)",
                      height: "100%",
                    }}
                  >
                    <DynamicForm
                      fields={checkboxinputconverter({ 
                        value: participant[0].isemppeerdecide ? false :  participant[3] && participant[3].isSelected,
                        placeholder: "",
                        label: "Co-workers",
                        disabled: participant[0].isemppeerdecide
                      })}
                      onChange={(value) =>
                        this.handleChange1("isSelected", value, 4)
                      }
                    />
                    <img
                      style={{ position: "absolute", top: 0 }}
                      src={coworkerImg}
                    ></img>
                  </div>
                </div>
              </div>

              {participant[1] && participant[1].isSelected && (
                <div>
                  <p className="small-dark-secondary margin-bottom-16">
                    *Specify manager level. Select atleast one.
                  </p>

                  <DynamicForm
                    fields={checkboxinputconverter({
                      value: participant[1] && participant[1].isprimarymanager,
                      placeholder: "",
                      label: "Include primary managers",
                    })}
                    onChange={(value) => {
                      this.handleChange("isprimarymanager", value, 2);
                    }}
                  />
                  <DynamicForm
                    fields={checkboxinputconverter({
                      value: participant[1].issecondarymanager,
                      placeholder: "",
                      label: "Include additional managers",
                    })}
                    onChange={(value) => {
                      this.handleChange("issecondarymanager", value, 2);
                    }}
                  />
                  <DynamicForm
                    fields={checkboxinputconverter({
                      value: participant[1] && participant[1].ismanagersmanager,
                      placeholder: "",
                      label: "Include manager’s manager",
                    })}
                    onChange={(value) => {
                      this.handleChange("ismanagersmanager", value, 2);
                    }}
                  />
                </div>
              )}

{participant[0] && participant[0].isSelected && (
                <div>
                  <p className="small-dark-secondary margin-bottom-16">
                  Let employee decide the selection of the Peer/Co-worker
                  </p>
                  <div className="margin-right-16">
                <div style={{ width: 140 }}>
                  <DynamicForm
                    className="width100"
                    fields={radioinputconverter({
                      value: participant[0].isemppeerdecide == true,
                      label: "Yes",
                    })}
                    onChange={() => this.handleChange1("isemppeerdecide", true, 1)}
                  />
                  <DynamicForm
                    className="width100"
                    fields={radioinputconverter({
                      value: participant[0].isemppeerdecide == false,
                      label: "No",
                    })}
                    onChange={() => this.handleChange1("isemppeerdecide", false, 1)}
                  />
                 
                </div>
              </div>
                 
                </div>
              )}

              <p className="normal-dark margin-bottom-8 display-flex">
                <img className="margin-right-16" src={pointingHandIcon}></img>{" "}
                Review submission window parameters
              </p>
              <p className="small-dark-secondary margin-bottom-16">
                When do you want review forms to open and close for submission
              </p>

              {reviewtypeid == 2 ? (
                <div
                  className="helping-hand-wrapper floatleft"
                  style={{ padding: 8, width: 332 }}
                >
                  <p className="helping-hand-text text-center text-center">
                    Helping Hand 👋
                  </p>
                  <p className="extra-small-dark-secondary margin-top-8">
                    Review window will be defined when creating review form
                    since you have selected ‘Manual’ review period.
                  </p>
                </div>
              ) : (
                  <div style={{ width: 350 }}>
                    <DynamicForm
                      fields={selectinputconverter({
                        value: formopentypeid,
                        placeholder: "Select when to open the review",
                        label: "Review window opening",
                        options: formopenoptions,
                      })}
                      onChange={(selectedid) => {
                        this.handleChange("formopentypeid", selectedid);
                      }}
                    />
                    <DynamicForm
                      fields={selectinputconverter({
                        value: formclosetypeid,
                        placeholder: "Select when to close the review",
                        label: "Review window closing",
                        options: formcloseoptions,
                      })}
                      onChange={(selectedid) => {
                        this.handleChange("formclosetypeid", selectedid);
                      }}
                    />
                  </div>
                )}
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}
export default withSnackbar(reviewperiod);
